import Component from 'inferno-component';
import Page from '../components/Page';
import '../assets/styles/index.css';

class Feedback extends Component {
  render() {
    return (
      <Page title="Feedback">
        <div className="about__container">
          <h2 className="about__header">E lekauila mai i kou manaʻo</h2>
          <div className="about__body">
            <p>
              Please email us with your feedback:
              <a href="mailto:manomano@kailoa.org"> manomano@kailoa.org</a>
            </p>
          </div>
        </div>
      </Page>
    );
  }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/pages/Feedback.js